"use client";

import PopularListItemCard from "@/components/PopularListItemCard";
import ThemeCard from "@/components/pages/hotel/cards/ThemeCard.jsx";
import OpportunitiesCardWrapper from "@/components/OpportunitiesCardWrapper";

import PopularLocationCard from "@/components/PopularLocationCard"; //
import { AppBanner, BenefitCard, BlogCard, CampaignCard, RegisterBanner } from "@/components/featured/common";

export const hotelHomeComponentRegistry = {
  OpportunitiesCardWrapper,
  CampaignCard,
  PopularListItemCard,
  BenefitCard,
  ThemeCard,
  BlogCard,
  AppBanner,
  PopularLocationCard,
  RegisterBanner,
};

export const hotelHomeItemPropMapping = {
  OpportunitiesCardWrapper: "stats",
  CampaignCard: "item",
  PopularListItemCard: "item",
  BenefitCard: "item",
  ThemeCard: "item",
  BlogCard: "post",
  PopularLocationCard: "item",
};
